import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {AuthService} from "../../core/services/auth.service";
import {HttpClient} from "@angular/common/http";
import {STORAGE_NAME} from "../../core/constants/constants";
import {CookieService} from "@app/core/services/cookie.service";


@Component({
  selector: 'app-auth-logout',
  template: ''
})
export class AuthLogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private cookieService: CookieService
  ) {}

  ngOnInit(): void {
      this.cookieService.delete(STORAGE_NAME.ACCESS_TOKEN);
      this.cookieService.delete(STORAGE_NAME.REFRESH_TOKEN);
      this.cookieService.delete(STORAGE_NAME.EXPIRES_AT);
      this.cookieService.delete(STORAGE_NAME.PKCE_CODE_VERIFIER);
      this.router.navigateByUrl('/').then();
  }

}


